import React from 'react';

import {
  ActionMenuItemClickedEventHandler,
  ContentClickedEventHandler,
  ContentTelemetryEventHandlers,
  ExploreDisplayMode,
  FavoriteToggleClickedEventHandler
} from '../../common/telemetryEvents/types/ContentTelemetryTypes';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { IRelatedContentInfo } from '../../ts/models/resourceInfoParts';

export type ContentClickedChildFunction = (fn: ContentClickedEventHandler) => React.ReactElement;
export type ContentClickedTelemetryContextValueType = (childFunction: ContentClickedChildFunction) => React.ReactElement;
export type ContentClickedTelemetryContextType = React.Context<ContentClickedTelemetryContextValueType>;

export type FavoriteToggleClickedChildFunction = (fn: FavoriteToggleClickedEventHandler) => React.ReactElement;
export type FavoriteToggleClickedTelemetryContextValueType = (childFunction: FavoriteToggleClickedChildFunction) => React.ReactElement;
export type FavoriteToggleClickedTelemetryContextType = React.Context<FavoriteToggleClickedTelemetryContextValueType>;

export type ActionMenuItemClickedChildFunction = (fn: ActionMenuItemClickedEventHandler) => React.ReactElement;
export type ActionMenuItemClickedTelemetryContextValueType = (childFunction: ActionMenuItemClickedChildFunction) => React.ReactElement;
export type ActionMenuItemClickedTelemetryContextType = React.Context<ActionMenuItemClickedTelemetryContextValueType>;

export type TelemetryChildFunctions = (fn: ContentTelemetryEventHandlers) => React.ReactElement;
export type TelemetryContextTypes = ContentClickedTelemetryContextType | FavoriteToggleClickedTelemetryContextType | ActionMenuItemClickedTelemetryContextType;
export type TelemetryContextValues = ContentClickedTelemetryContextValueType | FavoriteToggleClickedTelemetryContextValueType | ActionMenuItemClickedTelemetryContextValueType;

// Telemetry Handler contexts
export const ContentClickedTelemetryContext: ContentClickedTelemetryContextType = React.createContext<ContentClickedTelemetryContextValueType>((childFunction) => childFunction(() => {}));
export const FavoriteToggleClickedTelemetryContext: FavoriteToggleClickedTelemetryContextType = React.createContext<FavoriteToggleClickedTelemetryContextValueType>((childFunction) => childFunction(() => {}));
export const ActionMenuItemClickedTelemetryContext: ActionMenuItemClickedTelemetryContextType = React.createContext<ActionMenuItemClickedTelemetryContextValueType>((childFunction) => childFunction(() => {}));

/* Telemetry Data contexts */

// Common Contexts
export const ContentInfoContext: React.Context<IContentInfo> = React.createContext<IContentInfo>(null);

// Related Content Context
export const RelatedContentInfoContext: React.Context<IRelatedContentInfo> = React.createContext<IRelatedContentInfo>(null);

// Card releated data contexts
export const CardPositionContext: React.Context<number> = React.createContext<number>(null);

// Explore page related data contexts
export const ExplorePageDisplayModeContext: React.Context<ExploreDisplayMode> = React.createContext(null);

// Search 
export const SearchTermDataContext: React.Context<string> = React.createContext<string>(null);

/* END- Telemetry Data contexts */
